import React, { useEffect, useState } from "react";
import { getUser } from "../../../redux/user/action";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "../../Common/CustomInput/CustomInput";
import ReactSelect from "react-select";
import { useNavigate } from "react-router-dom";
import { addWallet, getAllWalletValidity } from "../../../redux/wallet/action";
import Spinner from "../../Layouts/Spinner";

const CreateWallet = () => {
  const list = useSelector((state) => state.reusableSlice.WalletValidityList);
  const userlist = useSelector(
    ({ user: { userlist } }) => userlist?.users || []
  );
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState([]);
  const [validity, setValidity] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [params] = useState({
    type: 1,
    search_key: "",
    status: "",
  });

  useEffect(() => {
    dispatch(getAllWalletValidity(params));
  }, [dispatch, params]);

  useEffect(() => {
    dispatch(getUser(params));
  }, [dispatch, params]);

  const formik = useFormik({
    initialValues: {
      reference: "",
      amount: "",
      complain: "",
      usage_percentage: 100,
    user_id: "",
      additional_type: 1,
      type: 1,
      validity: null,
    },
    validationSchema: Yup.object({
      reference: Yup.string().required("Reference code is required"),
      amount: Yup.number()
        .typeError("Amount must be a number")
        .min(0, "Amount must be positive")
        .required("Amount is required"),
      complain: Yup.string().required("Complain is required"),
      user_id: Yup.string()
  .required("User is required")
  .test("is-valid-user-ids", "Invalid user IDs", (value) => {
    if (!value) return false;
    return value
      .split(",")
      .every((id) => /^\d+$/.test(id.trim()));
  }),
      additional_type: Yup.number()
        .oneOf([1, 2], "Invalid additional type")
        .required("Additional Type is required"),
      type: Yup.number()
        .oneOf([1, 2], "Invalid type")
        .required("Type is required"),
      validity: Yup.number()
        .typeError("Validity must be a number")
        .min(1, "Validity must be at least 1")
        .required("Validity is required"),
      usage_percentage: Yup.number()
        .typeError("Usage percentage must be a number")
        .min(0, "Minimum is 0")
        .max(100, "Maximum is 100")
        .required("Usage percentage is required"),
    }),
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
    };
    dispatch(addWallet(data, setLoading, navigate));
  };

  const proUserOptions = userlist.map((item) => ({
    value: item.id,
    label: item.mobile_number || item.email_id || "-",
  }));

  const handleChangeuser = (selected) => {
  setUser(selected || []);
  const userIds = (selected || []).map((item) => item.value);
  formik.setFieldValue("user_id", userIds.join(","));
  formik.setFieldTouched("user_id", true);
};

  const additionalTypeOptions = [
    { label: "Advertising", value: 1 },
    { label: "Compensation", value: 2 },
  ];

  const typeOptions = [
    { label: "Credit", value: 1 },
    { label: "Debit", value: 2 },
  ];

  const durationTypeMap = {
    1: "Unlimited",
    2: "Days",
    3: "Weeks",
    4: "Months",
    5: "Years",
  };

  const proValidityOptions = list.map((item) => ({
    value: item.id,
    label:
      item.duration_type === 1
        ? durationTypeMap[item.duration_type]
        : `${item.duration} ${durationTypeMap[item.duration_type]}`,
  }));

  console.log(formik.values, "list");
  return (
    <div className="card-head order-card order-timing">
      <form onSubmit={formik.handleSubmit}>
        <h2 className="text-xl font-semibold mb-4">Add Wallet</h2>

        <div className="row">
          {/* Select Users */}
          <div className="col-md-6 mb-3">
            <label className="block mb-1 font-medium">Select Users</label>
            <ReactSelect
              value={user}
              onChange={handleChangeuser}
              options={proUserOptions}
              isMulti
              placeholder="Select User(s)"
              onBlur={() => formik.setFieldTouched("user_id", true)}
            />
            {formik.touched.user_id && formik.errors.user_id && (
              <div className="error">{formik.errors.user_id}</div>
            )}
          </div>

          {/* Additional Type */}
          <div className="col-md-6 mb-3">
            <label className="block mb-1 font-medium">Additional Type</label>
            <ReactSelect
              name="additional_type"
              options={additionalTypeOptions}
              value={additionalTypeOptions.find(
                (option) => option.value === formik.values.additional_type
              )}
              onChange={(selectedOption) =>
                formik.setFieldValue("additional_type", selectedOption.value)
              }
              onBlur={() => formik.setFieldTouched("additional_type", true)}
              placeholder="Select Additional Type"
            />
            {formik.touched.additional_type &&
              formik.errors.additional_type && (
                <div className="error">{formik.errors.additional_type}</div>
              )}
          </div>

          {/* Type */}
          <div className="col-md-6 mb-3">
            <label className="block mb-1 font-medium">Type</label>
            <ReactSelect
              name="type"
              options={typeOptions}
              value={typeOptions.find(
                (option) => option.value === formik.values.type
              )}
              onChange={(optionType) =>
                formik.setFieldValue("type", optionType.value)
              }
              onBlur={() => formik.setFieldTouched("type", true)}
              placeholder="Select Type"
            />
            {formik.touched.type && formik.errors.type && (
              <div className="error">{formik.errors.type}</div>
            )}
          </div>

          {/* Reference */}
          <div className="col-md-6 mb-3">
            <label className="block mb-1 font-medium">Reference Code</label>
            <CustomInput
  placeholder="Enter Reference Code"
  name="reference"
  value={formik.values.reference}
  onChange={(e) => {
    const alphaNumericValue = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
    formik.setFieldValue("reference", alphaNumericValue);
  }}
  onBlur={formik.handleBlur}
  error={formik.errors.reference}
  touched={formik.touched.reference}
/>

          </div>

          {/* Amount */}
          <div className="col-md-6 mb-3">
            <label className="block mb-1 font-medium">Amount</label>
            <CustomInput
              name="amount"
              placeholder="Enter Amount"
              type="number"
              value={formik.values.amount}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.errors.amount}
              touched={formik.touched.amount}
            />
          </div>

          {/* Usage Percentage */}
          <div className="col-md-6 mb-3">
            <label className="block mb-1 font-medium">Usage Percentage</label>
            <CustomInput
              name="usage_percentage"
              type="number"
              placeholder="Enter Usage Percentage"
              value={formik.values.usage_percentage}
              onChange={(e) => {
                const value = Math.min(100, Number(e.target.value));
                formik.setFieldValue("usage_percentage", value);
              }}
              onBlur={formik.handleBlur}
              error={formik.errors.usage_percentage}
              touched={formik.touched.usage_percentage}
              max={100}
            />
          </div>

          {/* Validity */}
          <div className="col-md-6 mb-3">
            <label className="block mb-1 font-medium">Validity</label>
            <ReactSelect
              value={
                proValidityOptions.find(
                  (option) => option.value === formik.values.validity
                ) || null
              }
              onChange={(selected) => {
                formik.setFieldValue(
                  "validity",
                  selected ? selected.value : null
                );
                setValidity(selected); // optional: if you're tracking locally
              }}
              options={proValidityOptions}
              placeholder="Select"
              onBlur={() => formik.setFieldTouched("validity", true)}
            />
            {formik.touched.validity && formik.errors.validity && (
              <div className="text-danger">{formik.errors.validity}</div>
            )}
          </div>

          {/* Complain */}
          <div className="col-md-6 mb-3">
            <label className="block mb-1 font-medium">Complain</label>
            <CustomInput
              name="complain"
              placeholder="Enter Complain"
              as="textarea"
              value={formik.values.complain}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.errors.complain}
              touched={formik.touched.complain}
            />
          </div>
        </div>

        <div
          className="d-flex align-items-center justify-content-between back-update"
          style={{ columnGap: "20px" }}
        >
          <button
            className="back-btn"
            onClick={() => {
              navigate("/wallet/list");
            }}
            style={{ width: "max-content" }}
            type="button"
          >
            Back
          </button>
          <button
            className="submit-btn"
            style={{ width: "max-content" }}
            type="submit"
          >
            {!loading ? "Submit" : <Spinner />}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateWallet;
